/*============================================================================
  Add to cart, from the product card.

  The button opens the quick view stripped down to the pickers. It never adds
  anything by itself — the product's own form does that, inside the quick view.
  See snippets/product-grid-atc.liquid for why that matters.

  ---------------------------------------------------------------------------
  THIS FILE NEVER OPENS THE PRODUCT PAGE

  There is no window.location anywhere below, and the thing being clicked is
  a <button> with no href. Opening a product page from this button is not
  something that can go wrong here — there is no code for it.

  That is deliberate. It was an <a href> before, as a fallback for a failed
  load, and it kept being followed: theme.js returns out of
  Modal.prototype.open BEFORE its preventDefault whenever it believes the
  modal is already open, and the browser did what browsers do with a link.

  When the quick view cannot be shown the button stops spinning and says so
  in the console. It does not send anybody anywhere.

  ---------------------------------------------------------------------------
  WHY THE QUICK VIEW IS LOADED HERE AND NOT BY theme.preloadProductModal

  The theme loads it on mouseover, and only on desktop — a phone never gets
  one. Calling the theme's loader on the click as well means two fetches for
  the same card racing each other, and the loser wipes the winner's markup out
  of the holder with innerHTML = "" while the modal is open.

  So the load happens here, once per product, and it steps aside when the
  theme's own preload got there first.
==============================================================================*/
(function () {
  var loading = {};

  /* ------------------------------------------------------------------ bits */

  function context(el) {
    var card = el.closest('.grid-product');
    if (!card) {
      return null;
    }

    var handle = card.getAttribute('data-product-handle');
    var id = card.getAttribute('data-product-id');
    if (!handle || !id) {
      return null;
    }

    return {
      card: card,
      handle: handle,
      id: id,
      // Where the quick view markup goes. No holder means the quick view is
      // switched off in Theme settings, and this button has nothing to open.
      holder: document.getElementById('QuickShopHolder-' + handle),
      modal: document.getElementById('QuickShopModal-' + id)
    };
  }

  function usable(ctx) {
    return !!(
      ctx &&
      ctx.holder &&
      ctx.modal &&
      window.theme &&
      theme.Modals &&
      theme.routes &&
      theme.sections
    );
  }

  function keep(el) {
    if (el) {
      el.setAttribute('data-quick-add-keep', '');
    }
  }

  /*
    Which blocks survive the stripping. Decided here rather than in the
    stylesheet because the block that matters carries no class of its own —
    the picker and the form sit together inside a plain .product-block. The
    way in is [data-variant-picker-mount]: find the block from the inside out,
    mark it, and let the stylesheet hide its unmarked siblings.

    WHEN this runs is the whole trick. The quick view arrives as a shell with
    an empty [data-blocks-holder]; the price, the pickers and Add to cart are
    fetched from the product page and dropped in later, by theme.js, once the
    modal is already open. So marking at click time finds nothing. The theme
    announces the arrival with 'quickview:loaded', and that is the moment that
    counts — see the listener at the bottom of this file.
  */
  function markKeepers(modal) {
    var mount = modal.querySelector('[data-variant-picker-mount]');
    if (!mount || !mount.closest) {
      // The blocks have not arrived yet, so there is nothing to mark. The
      // stylesheet waits for the flag set at the end of this function before
      // it hides anything, so an unmarked quick view shows whole rather than
      // showing empty. Getting that backwards means a modal with a title and
      // nothing else in it.
      return false;
    }

    keep(mount.closest('.product-block'));
    keep(modal.querySelector('.product-block--price'));

    /*
      On a product where an app does the choosing, the app's block is not
      clutter — it IS the picker, and hiding it leaves a bundle with nothing
      to configure. product-grid-item.liquid marks those products on the card;
      the click listener below copies the mark onto the modal, because by the
      time the blocks arrive whatever was clicked is long out of reach.

      Only foxsell, named rather than "every app block", because on a strap
      the very same block is a Buy 2 Get 1 upsell and the whole point of this
      screen is not showing it.
    */
    if (modal.hasAttribute('data-quick-add-app-picker')) {
      var groups = modal.querySelectorAll('[data-product-blocks]');
      var inner = groups[groups.length - 1];
      if (inner) {
        Array.prototype.forEach.call(inner.children, function (child) {
          if (child.matches('[class*="foxsell"]') || child.querySelector('[class*="foxsell"]')) {
            keep(child);
          }
        });
      }
    }

    // And the holder, which is easy to miss: the shell carries a
    // [data-product-blocks] of its own, and its one child is the holder
    // theme.js drops the product page's blocks into. That holder is a direct
    // child of a [data-product-blocks], so the hiding rule matches it — and
    // hiding it takes the pickers and Add to cart down with it, since they
    // live inside.
    keep(modal.querySelector('[data-blocks-holder]'));

    modal.setAttribute('data-quick-add-ready', '');
    return true;
  }

  /* ------------------------------------------------------------- the load */

  function load(ctx) {
    if (loading[ctx.handle]) {
      return loading[ctx.handle];
    }

    // The theme's hover preload beat us to it. Nothing to do.
    if (ctx.holder.children.length) {
      loading[ctx.handle] = Promise.resolve();
      return loading[ctx.handle];
    }

    var url = (theme.routes.home + '/products/' + ctx.handle + '?view=modal').replace('//', '/');

    loading[ctx.handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(url + ' answered ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        // Checked again: the theme's preload may have landed while we fetched.
        // Overwriting it here is what makes an open modal go blank.
        if (ctx.holder.children.length) {
          return;
        }

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.product-section[data-product-handle="' + ctx.handle + '"]');
        if (!section) {
          throw new Error('no .product-section in ' + url);
        }

        ctx.holder.innerHTML = '';
        ctx.holder.appendChild(section);

        // The same wiring theme.preloadProductModal does, in the same order.
        new theme.Modals('QuickShopModal-' + ctx.id, 'quick-modal-' + ctx.id);
        theme.sections.register('product', theme.Product, ctx.holder);
        if (theme.collapsibles) {
          theme.collapsibles.init();
        }

        // The theme's own hover button, so it stops reading "not ready".
        var hover = ctx.card.querySelector('.quick-product__btn');
        if (hover) {
          hover.classList.remove('quick-product__btn--not-ready');
        }
      })
      .catch(function (err) {
        delete loading[ctx.handle];
        throw err;
      });

    return loading[ctx.handle];
  }

  /* ------------------------------------------------------------- the open */

  var opening = false;

  function open(link, modal) {
    // theme.Modals binds its opener to the link itself, so a click is how it
    // is asked to open. The capture listener cancels that click on the way
    // through, so it cannot navigate even when theme.Modals ignores it.
    //
    // The flag is what stops this from being a loop. When theme.Modals IS
    // bound it stops the event and the listener below never sees it — but
    // when it is not, this click reaches that listener, which would call
    // open() again, which would click again, forever.
    opening = true;
    try {
      link.click();
    } finally {
      opening = false;
    }
    return modal.classList.contains('modal--is-active');
  }

  function failed(why, err) {
    // Nowhere to send anyone. The quick view is the only thing this button
    // does, so when it will not come up the button simply stops spinning.
    console.error('[grid-add-to-cart] ' + why, err || '');
  }

  /* ------------------------------------- making the app's own script run */

  /*
    The bundle builder arrives dead, and this is what revives it.

    theme.js fetches the product page, parses it with DOMParser and appends
    what it finds. A <script> that has been through DOMParser never executes
    when it lands in the document — so the builder's markup and stylesheet
    arrive, and its JavaScript does not. Reading the network back confirmed
    it: foxsell-shade.css was fetched, foxsell-shade.js never was.

    What it looked like from outside was "the picker does not work". The radio
    buttons did change, because a <label> pointing at a radio is the browser's
    own behaviour and needs nobody's script — but nothing was listening, so
    the bundle was never told. The proof is the field the cart actually reads:

        properties[__foxsell:dynamic_add_on_bundle_items]

    which held one variantId no matter what was clicked. That is the same
    field whose absence produced "Bundle selection not found" once before.

    So the script tags are replaced with fresh ones, which do run. Three
    things make that safe rather than reckless:

      - only scripts that mention foxsell are touched, so the page's other
        tenants are left alone. Of the nine inline scripts that come with the
        product page not one contains analytics, so nothing is double counted;
      - they run in document order, waiting on the external file before
        carrying on, because the inline config has to exist before the library
        reads it. Skipping that wait raised
        "Cannot read properties of undefined (reading 'config')";
      - once per modal, guarded by the attribute below.

    Verified on Magnus Collection: the library loads, window.foxsell appears,
    the console stays clean, and the bundle_items property follows the click.
  */
  function runAppScripts(modal) {
    if (modal.hasAttribute('data-quick-add-apps-run')) {
      return;
    }
    modal.setAttribute('data-quick-add-apps-run', '');

    var pending = Array.prototype.filter.call(modal.querySelectorAll('script'), function (el) {
      return /foxsell/i.test(el.src || '') || /foxsell/i.test(el.textContent || '');
    });

    (function next() {
      var old = pending.shift();
      if (!old || !old.parentNode) {
        return;
      }

      var fresh = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (attr) {
        fresh.setAttribute(attr.name, attr.value);
      });

      if (old.src) {
        fresh.onload = next;
        fresh.onerror = function () {
          console.error('[grid-add-to-cart] the bundle builder would not load: ' + fresh.src);
        };
      } else {
        fresh.textContent = old.textContent;
      }

      old.parentNode.replaceChild(fresh, old);

      // An inline script has already finished by the time it is in the
      // document; an external one carries on from its onload.
      if (!old.src) {
        next();
      }
    })();
  }

  /* ------------------------------------------------- capture: cancel early */

  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || !target.closest) {
        return;
      }

      /*
        Both openers are handled, and that is deliberate.

        The theme's own Quick view button used to be left alone, on the
        reasoning that "quick view" ought to show the product whole. What it
        actually showed was the product page in miniature, with the option
        buttons squeezed into a narrow column and — on a bundle — a builder
        that could not be operated at all, since the app's script never ran.
        Two buttons on the same card behaving differently, one of them badly.

        So they now open the same screen. Whichever was pressed, the modal is
        reduced, the app's script is revived and the pickers get the full
        width.
      */
      var opener = target.closest('[data-grid-atc-options], .quick-product__btn');
      if (!opener) {
        return;
      }

      var ctx = context(opener);
      if (!usable(ctx)) {
        return; // Nothing we can do. The button stays put.
      }

      // Ours to decide from here, including whether anything navigates. The
      // theme's opener is a div with nowhere to go, so this costs it nothing.
      evt.preventDefault();

      /*
        Copied from the card onto the modal because markKeepers runs again
        later, when the blocks finally arrive, and by then whatever was
        clicked is long out of reach.
      */
      if (ctx.card.hasAttribute('data-grid-atc-app-picker')) {
        ctx.modal.setAttribute('data-quick-add-app-picker', '');
      } else {
        ctx.modal.removeAttribute('data-quick-add-app-picker');
      }

      // Empty on the first click, filled on the one after the load.
      markKeepers(ctx.modal);
      ctx.modal.classList.add('modal--quick-add');
    },
    true
  );

  /* ------------------------------ bubble: only when nothing else handled it */

  document.addEventListener('click', function (evt) {
    // This is open() clicking the link to ask theme.Modals to open. Ignore it,
    // or it comes straight back here and clicks again.
    if (opening) {
      return;
    }

    var target = evt.target;
    if (!target || !target.closest) {
      return;
    }

    var link = target.closest('[data-grid-atc-options]');
    if (!link) {
      return;
    }

    var ctx = context(link);
    if (!usable(ctx)) {
      return;
    }

    // Getting here means theme.Modals did not take the click — it stops the
    // event on its way past whenever it is bound. So either the quick view
    // still has to be built, or it is built and nothing is listening.
    if (ctx.holder.children.length) {
      if (!open(link, ctx.modal)) {
        failed('the quick view is built but would not open');
      }
      return;
    }

    link.classList.add('btn--loading');

    load(ctx)
      .then(function () {
        link.classList.remove('btn--loading');
        if (!open(link, ctx.modal)) {
          failed('the quick view loaded but would not open');
        }
      })
      .catch(function (err) {
        link.classList.remove('btn--loading');
        failed('could not load the quick view:', err);
      });
  });

  /* -------------------------------------- the blocks arriving, late */

  /*
    theme.js fires this once it has fetched the price, the pickers and Add to
    cart from the product page and put them in the open modal. Until now there
    was nothing to mark — the modal was a shell.

    Every open quick-add modal is re-marked rather than just the one named in
    the event, because the id it carries is the section's ("main" for every
    product) and identifies nothing. Marking is setting an attribute that may
    already be set, so doing it twice costs nothing.
  */
  document.addEventListener('quickview:loaded', function () {
    document.querySelectorAll('.modal--quick-add').forEach(function (modal) {
      markKeepers(modal);
      if (modal.hasAttribute('data-quick-add-app-picker')) {
        runAppScripts(modal);
      }
    });
  });
})();
